import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { Editor } from "primereact/editor";
import store from "../../../../store/store";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { Card } from "react-bootstrap";
import { getTaskStatus } from "../../../../services/setup/user/userSetupService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchJourneyTeam from "../../crm/journey/searchJourneyTeam";
import SearchUser from "../users/searchUser";
import { DialogActions } from "@material-ui/core";

function TaskFormContent({ journeyID = 0, onCloseDialog }) {
  const { setFieldValue, values } = useFormikContext();
  const [userType, setUserType] = useState(1);
  const [taskStatus, setTaskStatus] = useState([]);
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const { auth } = store.getState();
  const { userID, fullName } = auth.user;
  useEffect(() => {
    getTaskStatusData();
  }, []);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-th-large"></i>
              <span>
                <strong>Task Card Basic Info</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <FormTextField label="Task Card Name" name="title" />
              <FormTextField
                label="Assigned To"
                name="userName"
                assignmeButton
                searchButton
                clearButton
                onAssignmeClick={() => {
                  setFieldValue("userID", userID);
                  setFieldValue("userName", fullName);
                }}
                onSearchClick={() => {
                  setUserType(1);
                  setOpenSearchUser(true);
                }}
                onClearFields={() => {
                  setFieldValue("userID", 0);
                  setFieldValue("userName", "");
                }}
                readonly
              />
              <FormTextField
                label="Reviewer"
                name="reviewer"
                assignmeButton
                searchButton
                clearButton
                onAssignmeClick={() => {
                  setFieldValue("reviewerUserID", userID);
                  setFieldValue("reviewer", fullName);
                }}
                onSearchClick={() => {
                  setUserType(2);
                  setOpenSearchUser(true);
                }}
                onClearFields={() => {
                  setFieldValue("reviewerUserID", 0);
                  setFieldValue("reviewer", "");
                }}
                readonly
              />
              <FormDateField name="deadlineDate" label="Deadline Date" />
              <FormSelectField
                label="Task Status"
                name="statusID"
                options={taskStatus}
              />
              <FormTextField
                label="Description"
                name="description"
                multiline
                minRows={5}
              />
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={onCloseDialog}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
      <DialogLayout
        open={openSearchUser}
        title="Search User"
        onCloseDialog={() => {
          setOpenSearchUser(false);
        }}
        maxWIdth="lg"
      >
        {journeyID > 0 ? (
          <SearchJourneyTeam
            journeyID={journeyID}
            onSelectUser={(user) => {
              setFieldValue("userID", user.userID);
              setFieldValue("userName", user.userName);
              setFieldValue("reviewerUserID", userID);
              setFieldValue("reviewer", fullName);
              setOpenSearchUser(false);
            }}
          />
        ) : (
          <SearchUser
            onSelectUser={(user) => {
              if (userType === 1) {
                setFieldValue("userID", user.ID);
                setFieldValue("userName", user.firstName + " " + user.lastName);
              } else if (userType === 2) {
                setFieldValue("reviewerUserID", user.ID);
                setFieldValue("reviewer", user.firstName + " " + user.lastName);
              }
              setOpenSearchUser(false);
            }}
          />
        )}

        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUser(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
  async function getTaskStatusData() {
    const statuses = [];
    const response = await getTaskStatus();
    const { data } = response.data;
    for (const status of data.taskStatuses) {
      statuses.push({
        value: status.ID,
        label: status.title,
      });
    }
    setTaskStatus(statuses);
  }
}

export default TaskFormContent;
